import { OrganisationsTyp, Verksamhetsinriktning } from 'src/types/nya/common';

export const ORGANISATIONS_TYP_LABELS: Record<OrganisationsTyp, string> = {
  BOSTADSRÄTTSFÖRENING: 'Bostadsrättsförening',
  EKONOMISK_FÖRENING: 'Ekonomisk förening',
  IDEELL_FÖRENING: 'Ideell förening',
  AKTIEBOLAG: 'Aktiebolag',
  FÖRETAG: 'Företag',
  ENSKILD_FIRMA: 'Enskild firma',
  OKÄND: 'Okänd',
};

export const VERKSAMHETSINRIKTNING_LABELS: Record<Verksamhetsinriktning, string> = {
  FÖRÄLDRAKOOPERATIV_FÖRSKOLA: 'Föräldrakooperativ förskola',
  VILLAFÖRENING: 'Villaförening',
  IDROTTSFÖRENING: 'Idrottsförening',
  KONSULT: 'Konsult',
  HANTVERK_OCH_BYGG: 'Hantverk och bygg',
  JORDBRUK_OCH_SKOG: 'Jordbruk och skog',
  HANDEL_OCH_E_HANDEL: 'Handel och e-handel',
  ÄKTA_BOSTADSRÄTTSFÖRENING: 'Äkta bostadsrättsförening',
  OÄKTA_BOSTADSRÄTTSFÖRENING: 'Oäkta bostadsrättsförening',
};

export function formatOrganisationsTyp(typ?: string | null): string {
  if (!typ) return '-';
  const uppercased = typ.toUpperCase() as OrganisationsTyp;
  return ORGANISATIONS_TYP_LABELS[uppercased] || typ;
}

export function formatVerksamhetsinriktning(inriktning?: string | null): string {
  if (!inriktning) return '-';
  const uppercased = inriktning.toUpperCase() as Verksamhetsinriktning;
  return VERKSAMHETSINRIKTNING_LABELS[uppercased] || inriktning;
}

/**
 * Formen och verksamheten i en rad, för en organisation som har båda.
 *
 * <p>"Ekonomisk förening · Villaförening" snarare än bara den ena. Formen är vad föreningen är
 * juridiskt, inriktningen vad den gör — och en yta som bara visar den ena av dem tvingar läsaren
 * att gissa vilken.
 */
export function formatOrganisationsform(
  typ?: string | null,
  inriktning?: string | null
): string {
  if (!inriktning) return formatOrganisationsTyp(typ);
  if (!typ) return formatVerksamhetsinriktning(inriktning);
  return `${formatOrganisationsTyp(typ)} · ${formatVerksamhetsinriktning(inriktning)}`;
}
